(() => {
  if (window.fdCourseLoaded) return;
  window.fdCourseLoaded = true;
  function init() {
    document.querySelectorAll('[data-course-purchase]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const form = root.querySelector('form');
      const button = form.querySelector('button[type="submit"]');
      const error = root.querySelector('[data-course-error]');
      form.addEventListener('change', event => {
        if (!event.target.matches('input[type="radio"]')) return;
        document.querySelectorAll('[data-course-purchase]').forEach(other => {
          const option = other.querySelector(`input[value="${event.target.value}"]:not(:disabled)`);
          if (option) { option.checked = true; other.querySelector('[data-course-total]').textContent = option.dataset.price; }
        });
      });
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (button.disabled) return;
        error.hidden = true;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        const items = [{ id: root.dataset.courseId, quantity: 1 }];
        if (form.querySelector('input[value="figure"]:checked')) items.push({ id: root.dataset.figureId, quantity: 1 });
        try {
          const response = await fetch(root.dataset.addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || 'Unable to add these items. Please try again.');
          window.location.assign(root.dataset.cartUrl);
        } catch (failure) {
          error.textContent = failure.message;
          error.hidden = false;
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      });
    });
    document.querySelectorAll('[data-course-comparison]').forEach(root => {
      if(root.dataset.ready) return;
      root.dataset.ready = 'true';
      root.querySelector('input')?.addEventListener('input',event => root.style.setProperty('--position',event.target.value+'%'));
    });
    const link = document.querySelector('[data-course-preview-link]');
    const video = document.querySelector('body:has(.fdc-course-marker) .shopify-section:has(video-media)');
    if(link && video) link.href = '#'+video.id;
  }
  document.addEventListener('shopify:section:load', init);
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
})();

(() => {
  function initialiseFAQs(scope = document) {
    scope.querySelectorAll('.fdg-faq-grid').forEach(grid => {
      if (grid.dataset.fdFaqReady) return;
      grid.dataset.fdFaqReady = 'true';
      const items = Array.from(grid.querySelectorAll(':scope > details'));
      const states = new Map();
      const desktop = matchMedia('(min-width: 750px)');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      function finish(item, expanded) {
        item.open = expanded;
        item.style.height = '';
        item.style.overflow = '';
      }
      function setExpanded(item, expanded) {
        const state = states.get(item);
        if (state.expanded === expanded && !state.animation) return;
        const start = item.getBoundingClientRect().height;
        state.animation?.cancel();
        state.expanded = expanded;
        item.dataset.faqExpanded = String(expanded);
        item.querySelector('summary').setAttribute('aria-expanded', String(expanded));
        item.open = true;
        item.style.height = 'auto';
        const styles = getComputedStyle(item);
        const closedHeight = item.querySelector('summary').getBoundingClientRect().height +
          parseFloat(styles.paddingTop) + parseFloat(styles.paddingBottom) +
          parseFloat(styles.borderTopWidth) + parseFloat(styles.borderBottomWidth);
        const end = expanded ? item.getBoundingClientRect().height : closedHeight;
        if (reduced.matches) { state.animation = null; finish(item, expanded); return; }
        item.style.overflow = 'hidden';
        const animation = item.animate({ height: [start + 'px', end + 'px'] }, {
          duration: 480, easing: 'cubic-bezier(.25,.8,.25,1)'
        });
        state.animation = animation;
        animation.onfinish = () => {
          if (state.animation !== animation) return;
          state.animation = null;
          finish(item, state.expanded);
        };
      }
      let initialOpen = false;
      items.forEach(item => {
        const expanded = item.open && !initialOpen;
        initialOpen ||= expanded;
        item.open = expanded;
        states.set(item, { expanded, animation: null });
        item.dataset.faqExpanded = String(expanded);
        const summary = item.querySelector('summary');
        summary.setAttribute('aria-expanded', String(expanded));
        summary.addEventListener('click', event => {
          event.preventDefault();
          const expand = !states.get(item).expanded;
          if (expand) items.forEach(other => {
            if (other !== item && states.get(other).expanded) setExpanded(other, false);
          });
          setExpanded(item, expand);
        });
      });
      function arrange() {
        items.forEach(item => {
          const state = states.get(item);
          state.animation?.cancel(); state.animation = null;
          finish(item, state.expanded);
        });
        if (desktop.matches) {
          const columns = [document.createElement('div'), document.createElement('div')];
          columns.forEach(column => column.className = 'fdg-faq-column');
          items.forEach((item, index) => columns[index % 2].append(item));
          grid.replaceChildren(...columns);
        } else grid.replaceChildren(...items);
      }
      arrange();
      desktop.addEventListener('change', arrange);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialiseFAQs(), { once: true });
  else initialiseFAQs();
  document.addEventListener('shopify:section:load', event => initialiseFAQs(event.target));
})();
